module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "kbx-progress-bar",
    staticStyle: {
      "width": "50%"
    },
    style: (_vm.getStyle()),
    attrs: {
      "klickbox-edit-item": "progress-bar-done",
      "klickbox-edit-item-dad": "progress",
      "klickbox-edit-label": _vm.$t('edit.canvas.past_item')
    }
  })])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-ee859f16!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/progressbar/percent/Done.vue
 ** module id = 921
 ** module chunks = 1
 **/